import { Component, Input, AfterViewInit } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-video-rendered',
  templateUrl: './video-rendered.component.html',
  styleUrls: ['./video-rendered.component.css']
})
export class VideoRenderedComponent extends ElementComponent implements AfterViewInit {
  @Input() override data: any = {
    src: '',
    ytVideoId: '',
    vimeoVideoId: ''
  }

  ngAfterViewInit() {
    setTimeout(() => this.youtube_parser(), 200);
    setTimeout(() => this.vimeo_parser(), 200);
  }

  private youtube_parser(): void {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = this.data.src.match(regExp);
    this.data.ytVideoId = (match && match[7].length == 11) ? match[7] : '';
  }

  private vimeo_parser(): void {
    var regExp = /https?:\/\/(www\.)?vimeo.com\/(channels\/(?:\w+\/)?|groups\/(?:\w+\/)?|album\/(?:\d+\/)?video\/|video\/|)(\d+)(?:$|\/|\?)/;
    var match = this.data.src.match(regExp);
    this.data.vimeoVideoId = (match && match[3]) ? match[3] : '';
  }
}
